import { BusFill30Icon } from "@vygruppen/spor-icon-react";
import {
  SharedContentGridLayout,
  SharedGridStyleBaseColor,
} from "features/CenterContent/shared/MainContentGrid";
import { breakpoint } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportLeftPanel";
import { AlternativeTransportRightPanelScroll } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/AlternativeTransportRightPanelScroll";
import { SimpleHeadedWidget } from "features/CenterContent/VehicleDetails/shared/SimpleHeadedWidget";
import { TimeInterval } from "shared/components/dataDisplay/TimeInterval";
import { NoDataMessage } from "shared/components/feedback/NoDataMessage/NoDataMessage";
import { Box, HStack, Text } from "shared/components/Spor";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import { hideOnWidthStyle } from "shared/utils/hideOnWidth";
import styled, { useTheme } from "styled-components";

const RightContentGrid = styled.div`
  ${SharedContentGridLayout};
  grid-template-columns: 1fr 1fr;
  grid-template-rows: min(220px) minmax(450px, auto);

  grid-template-areas:
    "shift-info shift-info"
    "shift-scroll shift-scroll";
  ${hideOnWidthStyle(breakpoint)};
  @container (width < 1850px) {
    grid-template-columns: 1fr;
    grid-template-rows: min(220px) 1fr;
    padding-bottom: 42px;
    grid-template-areas:
      "shift-info"
      "shift-scroll"
      "shift-scroll";
  }
  padding-bottom: 50px;
`;

const RightContentContainer = styled(Box)`
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  height: 100%;
  background-color: ${({ theme }) => theme.colorBackgroundMain};
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  border-left-width: 0px;
`;
interface AlternativeTransportRightPanelProps {
  vehicle: AlternativeTransportVehicle;
}

export const AlternativeTransportRightPanel = ({
  vehicle,
}: AlternativeTransportRightPanelProps) => {
  const theme = useTheme();

  if (!vehicle.workShiftPlan) {
    return (
      <RightContentContainer
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text fontWeight="400" fontSize="md">
          Ikke knyttet til skift
        </Text>
      </RightContentContainer>
    );
  }
  return (
    <RightContentContainer>
      <HStack pb="6px" pt="12px" minW="450px" minH="16px">
        <BusFill30Icon mb={2} />

        <Text fontWeight="700" fontSize="md" zIndex={1} minH="16px" minW="16px">
          Skift: {vehicle.workShiftPlan?.shiftId ?? ""}
        </Text>
      </HStack>
      <RightContentGrid>
        <SimpleHeadedWidget
          style={{ gridArea: "shift-info" }}
          panelStyle={SharedGridStyleBaseColor}
          headingLeft={<Text>Skiftinfo</Text>}
        >
          {vehicle.operatorName && vehicle?.workShiftPlan?.workShiftTrips ? (
            <>
              <Text color={theme.colorTextSecondary}>
                {vehicle.operatorName}
              </Text>
              <HStack>
                <TimeInterval
                  startTime={
                    vehicle?.workShiftPlan?.workShiftTrips[0]
                      ?.scheduledDepartureTimeOrigin
                  }
                  endTime={
                    vehicle?.workShiftPlan?.workShiftTrips &&
                    vehicle.workShiftPlan.workShiftTrips[
                      vehicle.workShiftPlan.workShiftTrips.length - 1
                    ]?.scheduledArrivalTimeDestination
                  }
                />
              </HStack>
            </>
          ) : (
            <NoDataMessage reason="Det finnes ikke skiftinfo denne bussen" />
          )}
        </SimpleHeadedWidget>

        <AlternativeTransportRightPanelScroll vehicle={vehicle} />
      </RightContentGrid>
    </RightContentContainer>
  );
};

export default AlternativeTransportRightPanel;
